import React from 'react';
import { motion } from 'framer-motion';

// Assets Imports
import prizeImg from '../assets/prize-giving.jpg';
import scienceImg from '../assets/science-day.jpg';

// 1. මෙතනට { onExploreGallery } ඇතුළත් කරන්න
const EventsSection = ({ onExploreGallery }) => {
  const events = [
    {
      id: 1,
      title: "Annual Prize Giving '24",
      tag: "Academic Excellence",
      image: prizeImg,
      desc: "Celebrating the exceptional achievements of our students in the past academic year."
    },
    {
      id: 2,
      title: "Science & Innovation Day",
      tag: "Exhibition",
      image: scienceImg,
      desc: "Exploring the future through the creative minds of our young scientists."
    }
  ];

  return (
    <section className="py-20 md:py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        
        {/* --- SECTION HEADER --- */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-8">
          <div className="space-y-3">
            <motion.div 
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              className="flex items-center gap-3"
            >
              <div className="w-10 h-[2px] bg-red-600"></div>
              <span className="text-red-600 font-black uppercase tracking-[0.4em] text-[10px]">Highlights</span>
            </motion.div>
            <motion.h2 
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.1 }}
              className="text-4xl md:text-6xl font-black text-indigo-950 uppercase tracking-tighter leading-none"
            >
              Latest <br/> <span className="text-red-600">Moments.</span>
            </motion.h2>
          </div>
          
          {/* 2. බට්න් එකට onClick={onExploreGallery} එකතු කරන්න */}
          <motion.button 
            onClick={onExploreGallery} 
            whileHover={{ x: 5 }}
            className="group flex items-center gap-4 text-[11px] font-black uppercase tracking-[0.3em] text-indigo-950 hover:text-red-600 transition-colors"
          >
            Explore Gallery <span className="text-xl text-red-600 group-hover:translate-x-2 transition-transform">→</span>
          </motion.button>
        </div>

        {/* --- TWO MAIN EVENTS LAYOUT --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {events.map((event, index) => (
            <motion.div 
              key={event.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2 }}
              viewport={{ once: true }}
              className="group cursor-pointer"
            >
              {/* Image Container */}
              <div className="relative aspect-[16/10] overflow-hidden rounded-none shadow-2xl shadow-slate-200">
                <img 
                  src={event.image} 
                  alt={event.title} 
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-indigo-950/10 group-hover:bg-transparent transition-colors duration-500"></div>
                
                {/* Tag */}
                <div className="absolute top-6 left-6">
                  <span className="bg-white text-indigo-950 text-[9px] font-black uppercase tracking-widest px-5 py-2">
                    {event.tag}
                  </span>
                </div>
              </div>

              {/* Text Info */}
              <div className="mt-8 space-y-4">
                <h3 className="text-2xl md:text-3xl font-black text-indigo-950 uppercase tracking-tighter group-hover:text-red-600 transition-colors">
                  {event.title}
                </h3>
                <p className="text-slate-500 text-sm font-medium leading-relaxed max-w-md">
                  {event.desc}
                </p>
                <div className="pt-2">
                   <span className="text-[10px] font-black uppercase tracking-[0.4em] text-red-600 border-b-2 border-red-600/20 group-hover:border-red-600 transition-all pb-1">
                     View Details
                   </span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default EventsSection;